























































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import { DxToolbar, DxItem } from 'devextreme-vue/toolbar';
import { FileParseFormatService } from '@/service/FileParseFormatService';
import { FileParseCalculationService } from '@/service/FileParseCalculationService';
import {
  FileParseFormatDto,
  GetDefaultFileParseFormatDto
} from '@/models/file-parsing/FileParseFormatDto';
import { FileParseFormatFileExtensionDto } from '@/models/file-parsing/FileParseFormatFileExtensionDto';
import { FileParseColumnFilterDto } from '@/models/file-parsing/FileParseColumnFilterDto';
import { FileParseCalculationDto } from '@/models/file-parsing/FileParseCalculationDto';
import { FileParseFormatCalculationDto } from '@/models/file-parsing/FileParseFormatCalculationDto';
import {
  DxColumn,
  DxRequiredRule,
  DxEditing,
  DxDataGrid,
  DxForm,
  DxFormItem,
  DxHeaderFilter,
  DxPaging,
  DxPopup,  
  DxCustomRule,
  DxAsyncRule,
  DxLookup
} from 'devextreme-vue/data-grid';
import { DxButton, DxTextBox, DxCheckBox, DxTagBox, DxSelectBox, DxSortable, DxValidator } from 'devextreme-vue';
import { SelectOption } from '../models/SelectOption';
import { QuestelServicesClient, RequestResult } from '@questelservices/common';
import DevExpress from 'devextreme';
import { FileParseFormatColumnDto } from '../models/file-parsing/FileParseFormatColumnDto';
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import DataGrid from "devextreme/ui/data_grid";
import { FileParseTargetColumnOptionDto } from '@/models/file-parsing/FileParseTargetColumnOptionDto';
import _ from 'lodash';
import Form from 'devextreme/ui/form';
import { CurrencyService } from '@/service/CurrencyService';
import { CurrencyDto } from '@/models/CurrencyDto';
import FileParseFormatConfiguration from '@/components/file-parsing/file-parse-format-configuration.vue';
import DataSource from 'devextreme/data/data_source';

@Component({
  components: {
    PageTitle,
    DxToolbar,
    DxItem,
    DxColumn,
    DxRequiredRule,
    DxEditing,
    DxDataGrid,
    DxForm,
    DxFormItem,
    DxHeaderFilter,
    DxPaging,
    DxPopup,
    DxLookup,
    DxButton,
    DxTextBox,
    DxCheckBox,
    DxTagBox,
    DxSelectBox,
    DxSortable,
    DxValidator,
    DxCustomRule,
    DxAsyncRule,
    FileParseFormatConfiguration
  }
})
export default class FileParseFormatColumn extends Vue {
  $refs: Vue['$refs'] & {
    datagrid?: DataGrid;
  } = {};

  formatDto: FileParseFormatDto = GetDefaultFileParseFormatDto();
  dataGrid: any;
  fileExtensions: string[] = [];
  dataTypes: Array<SelectOption> = [];
  availableFilters: Array<FileParseColumnFilterDto> = [];
  selectedFileExtensions: string[] = [];
  availableCalculations: FileParseCalculationDto[] = [];
  currencies: CurrencyDto[] = [];
  showConfiguration: boolean = false;
  configuration: FileParseFormatConfiguration | null = null;
  targetColumnOptions: Array<FileParseTargetColumnOptionDto> = [];
  private readonly othersGroupLabel: string = 'Others';

  get targetColumnOptionsDataSource() {
    return new DataSource({
      store: this.targetColumnOptions,
      group: 'TableName',
      searchExpr: 'TargetColumnName'

    });
  }

  calculateTargetColumnNameSortValue(rowData: any) {
    if (rowData.FileParseTargetColumnOptionId != null) {
      let targetColumnOption = this.targetColumnOptions.find(o => o.FileParseTargetColumnOptionId === rowData.FileParseTargetColumnOptionId);
      if (targetColumnOption != null) {
        return targetColumnOption.TargetColumnName;
      }
    }
    
    return rowData.TargetColumnName;
  }

  private get fileParseFormatId(): Guid | undefined {
    return this.$route.params.id;
  }

  private fileParseFormatService: FileParseFormatService = new FileParseFormatService();
  private fileParseCalculationService: FileParseCalculationService = new FileParseCalculationService();
  private currencyService: CurrencyService = new CurrencyService();
  private client: QuestelServicesClient = new QuestelServicesClient(this.$store, '');

  async mounted() {
    if (this.fileParseFormatId) {
      this.formatDto = await this.fileParseFormatService.get(this.fileParseFormatId);

      // If copying an existing format, unset the primary keys
      if(this.$route.params['copyFromExisting']) {
        this.formatDto.FileParseFormatId = undefined;

        this.formatDto.FileExtensions.forEach(fe => {
          fe.FileParseFormatFileExtensionId = "00000000-0000-0000-0000-000000000000";
        });

        this.formatDto.FileParseFormatColumns.forEach(c => {
          c.FileParseFormatColumnId = "00000000-0000-0000-0000-000000000000";
        });
      }           

      // Set a file parse format id as a route parameter so the breadcrumb will load the selected format
      this.$route.params['fileParseFormatId'] = this.fileParseFormatId;
      this.selectedFileExtensions = this.formatDto.FileExtensions.map(fe => fe.FileExtension);
    } 
    else {
      this.formatDto = GetDefaultFileParseFormatDto();
    }

    this.formatNameValue = this.formatDto ? this.formatDto.Name : '';
    this.targetColumnOptions = await this.fileParseFormatService
      .getTargetColumnNameOptions() 
      .catch(err => []);

    this.formatDto.FileParseFormatColumns.forEach(item => {
      if (item.FileParseTargetColumnOptionId == null && item.TargetColumnName != null) {
        let maxId = _.maxBy(this.targetColumnOptions, item => item.FileParseTargetColumnOptionId);
        let id = (maxId ? maxId.FileParseTargetColumnOptionId : 0) + 1;

        let customItem = {
          "FileParseTargetColumnOptionId": id,
          "TableName": this.othersGroupLabel,
          "TargetColumnName": item.TargetColumnName,
          "DataType": item.DataType,
          "CustomItem": true
        };

        item.FileParseTargetColumnOptionId = id;
        this.targetColumnOptions.push(customItem);
      }
    });

    let extensions = await this.fileParseFormatService.getFileExtensions();
    this.fileExtensions = extensions;

    let types = await this.fileParseFormatService.getDataTypes();
    this.dataTypes = types.map(t => {
      return { text: t, value: t };
    });

    this.availableFilters = await this.client.get<FileParseColumnFilterDto[]>('/api/FileParseColumnFilters');
    this.availableCalculations = await this.fileParseCalculationService.getAll();
    this.currencies = await this.currencyService.getAll();
  }

  configurationInitialized(e: any) {
    this.configuration = e.component;
  }

  openConfiguration() {
    this.showConfiguration = true;
  }

  closeConfiguration() {
    this.showConfiguration = false;
  }

  popupShowing(e: any) {
    this.removeUnusedCustomTargetColumn();

    // Couldn't find a configuration option for this, so changing the style of Save and Cancel when loading the dialog.
    var toolbarItems = e.component.option('toolbarItems');
    toolbarItems[0].options.stylingMode = 'contained';
    toolbarItems[0].options.text = 'OK';
    toolbarItems[1].options.stylingMode = 'contained';
    toolbarItems[1].options.type = 'normal';
    e.component.option('toolbarItems', toolbarItems);
  }

  onTargetColumnChanged(e: any, data: any) {
    let selectedTargetOption = this.targetColumnOptions.find(o => o.FileParseTargetColumnOptionId === e.value);
    if (selectedTargetOption != null) {
      data.setValue(selectedTargetOption.FileParseTargetColumnOptionId);
      
      // Also update the value of the DataType
      this.dataGrid.cellValue(data.row.rowIndex, this.dataGrid.getVisibleColumnIndex('DataType'), selectedTargetOption.DataType);
      this.repaintEditForm();
    }
  }

  onDataTypeChanged(e: any, data: any) {
    data.setValue(e.value);
  }

  onCustomItemCreatingEvent(e: any) {
    let alreadyExists = this.targetColumnOptions.find(item => item.TargetColumnName === e.text && item.TableName === this.othersGroupLabel);
    if (alreadyExists) {
      e.customItem = alreadyExists;
      return;
    }

    let maxId = _.maxBy(this.targetColumnOptions, item => item.FileParseTargetColumnOptionId);
    let id = (maxId ? maxId.FileParseTargetColumnOptionId : 0) + 1;

    let customItem = {
      "FileParseTargetColumnOptionId": id,
      "TableName": this.othersGroupLabel,
      "TargetColumnName": e.text,
      "DataType": 'string',
      "CustomItem": true
    };

    this.targetColumnOptions.push(customItem);
    e.customItem = customItem;
  }

  validateTargetColumn(e: any) {
    return this.validateTargetColumnValue(e.value);
  }

  validateTargetColumnValue(value: any){
    let result = true;
    if (value === this.targetColumnValue){
      result = true;
    } else if (value) {
      if (this.formatDto.FileParseFormatColumns.find(c => c.FileParseTargetColumnOptionId === value)) {
        result = false;
      } else {
        result = true;
      }
    }

    return result;
  }

  formatNameValue: string | undefined = '';
  async validateAsync(param: any) {
    if (this.formatNameValue == param.value || !param.value) {
      return true;
    }
    
    return await this.fileParseFormatService
      .checkFileParseFormatName(param.value)
      .then(response => {
        return !response;
      });
  }

  dataGridInitNewRow(e: any) {
    e.data = {
      IsRequired: false,
      IsEditable: false,
      FileParseColumnFilterIds: []
    };
  }

  rowInserting(e: any) {
    e.data.FileParseColumnFilterIds = e.data.FileParseColumnFilterIds.filter(
      (id: Guid) => id.length > 0
    );
  }
  
  rowUpdating(e: any) {
    // Add back any data not edited
    e.newData = Object.assign({}, e.oldData, e.newData);
    e.newData.FileParseColumnFilterIds = e.newData.FileParseColumnFilterIds.filter(
      (id: Guid) => id.length > 0
    );

    this.dataSaved = true;
  }

  rowUpdated(e: any) {
    if (this.configuration != null) {
      this.configuration.populateCalculationData();
    }

    (this.$refs.datagrid as any).instance.refresh();
  }

  removeUnusedCustomTargetColumn() {
    _.remove(this.targetColumnOptions, option =>
      option.TableName === this.othersGroupLabel && _.findIndex(this.formatDto.FileParseFormatColumns, column => column.TargetColumnName === option.TargetColumnName || column.FileParseTargetColumnOptionId === option.FileParseTargetColumnOptionId) === -1
    );
  }

  rowRemoved(e: any) {
    this.formatDto.DeletedFileParseFormatColumns.push(e.data);

    if (this.configuration != null) {
      this.configuration.populateCalculationData();
    }
    
    this.removeUnusedCustomTargetColumn();
  }

  dataGridInitialized(e: any): void {
    this.dataGrid = e.component;
  }

  saveFormat(e: any) {
    let result = e.validationGroup.validate();
    if (result.isValid) {
      this.submitSave();
    }    
  }

  submitSave() {
    this.dataGrid.focus();
    this.formatDto.FileExtensions = this.selectedFileExtensions
      .map(fe => {
        let fileExtension = new FileParseFormatFileExtensionDto();
        fileExtension.FileExtension = fe;
        return fileExtension;
      });

    let payload = _.cloneDeep(this.formatDto);

    this.targetColumnOptions
      .filter(item => item.TableName === this.othersGroupLabel)
      .forEach(item => {
        let notInOptions = payload.FileParseFormatColumns.find(c => c.FileParseTargetColumnOptionId === item.FileParseTargetColumnOptionId);

        if (notInOptions) {
          notInOptions.FileParseTargetColumnOptionId = undefined;
          notInOptions.TargetColumnName = item.TargetColumnName;
        }
      });
    
    if (payload.FileParseFormatId == undefined) {    
      let result = this.fileParseFormatService.create(payload).then(res => {
        this.returnToList();
        return res;
      }).catch(res => {
        this.handleSaveError(res);
      });
    } else {
      let result = this.fileParseFormatService.edit(payload.FileParseFormatId, payload).then(res => {
        this.returnToList();
        return res;
      }).catch(res => {
        this.handleSaveError(res);
      });
    }
  }

  private handleSaveError(result: any) {
    let message = 'An error occurred saving the file parse format.';
    if (result && result.Message) {
      message = result.Message;

      let index = message.indexOf(' (Error');
      if (index > -1) {
        message = message.substring(0, index);
      }
    }

    this.showErrorMessage(message);
  }

  private showErrorMessage(message: string) {
    notify({ message, position: 'top center' }, 'error', 7000);
  }

  deleteFormat(e: any) {
    confirm(`Are you sure you want to delete ${this.formatDto.Name}?`, 'Confirm')
      .then(result => {
        if (result && this.formatDto.FileParseFormatId != null) {
          this.fileParseFormatService.delete(this.formatDto.FileParseFormatId)
            .then(this.onFormatDeleted)
            .catch(this.handleDeleteError);
        }
      });
  }

  private onFormatDeleted(result: RequestResult) {
    notify({ message: `${this.formatDto.Name} successfully deleted.`, position: 'top center' }, 'success', 5000);
    this.returnToList();
  }

  private handleDeleteError(result: any) {
    this.showErrorMessage('An error occurred deleting the file parse format.');
  }

  returnToList() {
    this.$router.push({ path: '/file-parse-format' });
  }

  created(): void {
    document.addEventListener('keyup', this.onKeyup, true);
    document.addEventListener('keydown', this.onKeydown, true);
  }

  destroyed(): void {
    document.removeEventListener('keyup', this.onKeyup, true);
    document.removeEventListener('keydown', this.onKeydown, true);
  }

  onKeydown(e: any): void {
    if (e.key === 'Enter' && (e.ctrlKey || e.shiftKey)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  onKeyup(e: any): void {
    if (e.key === 'Enter' && (e.ctrlKey || e.shiftKey)) {
      e.preventDefault();
      e.stopPropagation();
      this.saveFormatGrid();
    }
  }

  saveFormatGrid() {
    if (this.dataGrid) {
      this.dataGrid.focus();
      this.dataGrid.saveEditData();
    }
  }

  // Store reference to form when initialized, to use for repainting later
  private columnEditForm: DevExpress.ui.dxForm | undefined = undefined;
  formInitialized(e: any) {
    this.columnEditForm = e.component;
  }

  repaintEditForm() {
    if (this.columnEditForm) {
      this.columnEditForm.repaint();
    }
  }

  targetColumnValue: string = '';

  // Get a copy of the filters when starting to edit that copy, to be able to restore it when editing is canceled.
  // There's possibly a better way of doing this if we spend more time on it.
  private currentEditColumnId: Guid = '';
  private selectedFilterIds: Guid[] = [];
  private dataSaved: boolean = false;
  dataGridEditingStart(e: any) {
    this.targetColumnValue = e.data.FileParseTargetColumnOptionId;    
    this.currentEditColumnId = e.data.FileParseFormatColumnId;
    // Create a copy of the array to restore if needed
    this.selectedFilterIds = [...e.data.FileParseColumnFilterIds];
    this.dataSaved = false;
  }

  popupHiding(e: any) {
    this.targetColumnOptionsDataSource.searchValue(null);
    this.targetColumnOptionsDataSource.filter(null);
    this.targetColumnOptionsDataSource.load();

    // If data was not saved, restore the original filter value.
    // This is a workaround to find a way of making cancel work.
    if (!this.dataSaved) {
      let column = this.formatDto.FileParseFormatColumns.find(
        c => c.FileParseFormatColumnId === this.currentEditColumnId
      );
      if (column) {
        column.FileParseColumnFilterIds = this.selectedFilterIds;
      }
    }
    this.dataSaved = false;
  }

  addFilterClick(e: any) {
    // Add empty value
    e.data.FileParseColumnFilterIds.push('');
    // Repaint form
    this.repaintEditForm();
  }

  removeFilterClick(data: any, index: number) {
    // Remove element at index
    data.data.FileParseColumnFilterIds.splice(index, 1);
    // Set column value to array
    data.setValue(data.data.FileParseColumnFilterIds);
    // Repaint form
    this.repaintEditForm();
  }

  getFilterRemoveButtonOptions(data: any, index: number) {
    return [
      {
        name: 'remove',
        options: {
          icon: 'trash',
          onClick: () => {
            this.removeFilterClick(data, index);
          }
        }
      },
      {
        name: 'drag',
        options: {
          icon: 'dragvertical',
          activeStateEnabled: false,
          focusStateEnabled: false,
          hoverStateEnabled: false,
          elementAttr: { class: 'filter-reorder-drag' }
        }
      }
    ];
  }

  filterValueChanged(value: any, data: any, index: number) {
    // Update value
    data.data.FileParseColumnFilterIds[index] = value.value;
    // Set column value to entire array
    data.setValue(data.data.FileParseColumnFilterIds);
    this.repaintEditForm();
  }

  filterReorder(e: any, data: any) {
    let movedItem = data.data.FileParseColumnFilterIds[e.fromIndex];
    data.data.FileParseColumnFilterIds.splice(e.fromIndex, 1);
    data.data.FileParseColumnFilterIds.splice(e.toIndex, 0, movedItem);
    // Update column value
    data.setValue(data.data.FileParseColumnFilterIds);
    this.repaintEditForm();
  }
}
